import React,{Component} from 'react';
class Navbar extends Component {
  render() {
    return(
<nav class="navbar navbar-expand-sm bg-dark navbar-dark sticky-top">
  <a class="navbar-brand" href="https://mdbootstrap.com/">
    <img src="https://i.ibb.co/jJgGBR3/R.png" width="30" height="30" class="d-inline-block align-top" alt="" />
    PLAY WITH BINARY SEARCH TREE
  </a>
</nav>
);
  }
}
export default Navbar;
